<section class="signup-dialog">
  <!-- dialog header -->
  <div>
    <div class="signup-dialog__header">
      <!-- title -->
      <h4 class="signup-dialog__title">
        @if (authService.userSignUpState().state === 0) {
          {{ 'auth.signup' | translate }}
        } @else if (authService.userSignUpState().state === 1) {
          {{ 'toastMessages.loginTitle' | translate }}
        }
      </h4>
      <!-- close button -->
      <button (click)="close(true)">
        <i class="iconsax signup-dialog__icon" icon-name="x"></i>
      </button>
    </div>
  </div>

  <div class="signup-dialog__container">
    @if (authService.userSignUpState().state === 0) {
      <form
        class="signup-dialog__form"
        (submit)="submit()"
        [formGroup]="signupForm">
        <div class="signup-dialog__field">
          <pwj-phone-number
            formControlName="mobile"
            label="auth.phoneNumber"
            placeholder="auth.enterPhoneNumber"
            icon="phone"></pwj-phone-number>
        </div>
        <div class="signup-dialog__field">
          <pwj-input
            formControlName="password"
            type="password"
            label="auth.passwordLabel"
            placeholder="auth.passwordPlaceholder"
            icon="lock-2"
            [messages]="{
              required: 'auth.passwordIsRequired',
              minlength: 'auth.passwordLength',
            }"></pwj-input>
        </div>
        <div class="signup-dialog__field">
          <pwj-input
            formControlName="password_confirmation"
            type="password"
            label="auth.repasswordLabel"
            placeholder="auth.repasswordPlaceholder"
            icon="lock-2"
            [messages]="{
              required: 'auth.repasswordIsRequired',
            }"></pwj-input>
        </div>
        @if (signupForm.errors?.['passwordNotMatch']) {
          <span class="signup-dialog__password-no-match">{{
            'auth.passwordNoMatch' | translate
          }}</span>
        }
        <div class="signup-dialog__submit">
          <!-- login button -->
          <pwj-button
            class="header-btn"
            buttonClasses="[&>span]:!font-500"
            size="large"
            [iconReversePosition]="true"
            [rotateIconInRtl]="true"
            (click)="openLoginDialog()"
            type="button">
            {{ 'auth.alreadyHaveAnAccount' | translate }}
            <span class="text-success-dark">{{
              'auth.login' | translate
            }}</span>
          </pwj-button>

          <!-- submit signup form -->
          <pwj-button
            variant="primary"
            type="submit"
            icon="chevron-right"
            size="large"
            buttonClasses="yektanet__signup-dialog-btn"
            matomoClickCategory="Authentication"
            matomoClickAction="Signup"
            matomoClickName="Form"
            [iconReversePosition]="true"
            [rotateIconInRtl]="true"
            [disabled]="!signupForm.dirty"
            >{{ 'auth.signup' | translate }}
          </pwj-button>
        </div>
      </form>
    } @else if (authService.userSignUpState().state === 1) {
      <form
        class="signup-dialog__form"
        (submit)="submitOtp()"
        [formGroup]="signupOtpForm">
        <div class="signup-dialog__field">
          <pwj-input
            formControlName="first_name"
            label="auth.firstName"
            placeholder="auth.enterFirstName"
            icon="user-2"
            [messages]="{
              required: 'auth.firstNameIsRequired',
            }"></pwj-input>
        </div>
        <div class="signup-dialog__field">
          <pwj-input
            formControlName="last_name"
            label="auth.lastName"
            placeholder="auth.enterLastName"
            icon="user-2"
            [messages]="{
              required: 'auth.lastNameIsRequired',
            }"></pwj-input>
        </div>
        <div class="signup-dialog__field">
          <pwj-input
            pwjOnlyNumber
            formControlName="otp"
            label="auth.verificationCode"
            [subLabel]="('global.sendToNumber' | translate) + ' ' + authService.userSignUpState().mobile?.prefix + authService.userSignUpState().mobile?.mobile_number"
            CustomCssSubLabel="text-7xl !text-gray-600"
            placeholder="auth.enterVerificationCode"
            icon="lock-2"
            [messages]="{
              required: 'auth.verificationCodeIsRequired',
            }"></pwj-input>
        </div>
        <div class="signup-dialog__resend-otp">
          @if (!showResendButton) {
            <p class="otp-timer">
              <span class="otp-timer__numbers">
                {{ formattedTimer }}
              </span>
              <span class="otp-timer__description">
                {{ 'auth.receiveCode' | translate }}
              </span>
            </p>
          } @else {
            <button
              type="button"
              class="resend-otp-button"
              (click)="resendOtp()">
              <span>
                {{ 'auth.getCodeAgain' | translate }}
              </span>
              <span>
                <i
                  class="iconsax resend-otp-button__icon"
                  icon-name="chevron-right"></i>
              </span>
            </button>
          }
        </div>
        <div class="signup-dialog__submit">
          <!-- login button -->
          <pwj-button
            class="header-btn"
            buttonClasses="[&>span]:!font-500"
            size="large"
            [iconReversePosition]="true"
            [rotateIconInRtl]="true"
            (click)="openLoginDialog()"
            type="button">
            {{ 'auth.alreadyHaveAnAccount' | translate }}
            <span class="!text-success-dark">{{
              'auth.login' | translate
            }}</span>
          </pwj-button>

          <!-- submit otp signup form -->
          <pwj-button
            variant="primary"
            type="submit"
            icon="chevron-right"
            size="large"
            buttonClasses="yektanet__signup-dialog-otp-btn"
            matomoClickCategory="Authentication"
            matomoClickAction="Verify OTP"
            matomoClickName="Form"
            [iconReversePosition]="true"
            [rotateIconInRtl]="true"
            [disabled]="!signupOtpForm.dirty || isVerifyOtpBtnDisable"
            >{{ 'global.send' | translate }}
          </pwj-button>
        </div>
      </form>
    }
  </div>
</section>
